module.exports = __webpack_public_path__ + "img/pcHand.e3077cc9.png";